export default __webpack_public_path__ + "static/media/phone.8d3b66ea.svg";